import { useEffect, useState } from "react";
import { useMobileIndex } from "../lib/hooks/useMobileIndex"
import { MobileIndexBody } from "./components/body";
import { MobileIndexSwitchers } from "./components/switchers";
import { OrderInfoProvider } from "entities/orders";

export const MobileIndex = () => {

  const {
    tabMode,
    setTabMode
  } = useMobileIndex();

  const [ isLoaded, setIsLoaded ] = useState(false);

  useEffect(()=>{
    setTimeout(() => {
      setIsLoaded(true);
    }, 500);
  })


  return (
    <>
      <MobileIndexSwitchers 
        tabMode={tabMode}
        setTabMode={setTabMode}
      />
      <OrderInfoProvider>
        <MobileIndexBody 
          tabMode={tabMode}
          isLoaded={isLoaded}
        />
      </OrderInfoProvider>
    </>
  )
}